// extracted by mini-css-extract-plugin
export default {"image":"cCTubR11hmAHDtX78Z0U"};